<template>
    <van-popup v-model="isShow" v-if='isShow' :close-on-click-overlay='closeOnClickOverlay'
               :closeable='closeable' safe-area-inset-bottom style='padding:5%;'
               :round='round'>
      <h2><slot name='title'/></h2>
      <slot name='content'>暂无内容</slot>
    </van-popup>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    }
  },
  props: {
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    round: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/base/BasePopup.vue